import { createContext } from 'react'

export default createContext({
  responseBySurveyQuestionId: {},
  createResponse: () => {},
  updateResponse: () => {},
  setOnChangeResponse: () => {},
  goToNextQuestion: () => {},
  scrollToTop: () => {},
  clientId: null,
  coachId: null,
  isCoach: null,
  progress: null,
  surveyProgress: null,
  requiredSurveyProgress: null,
  client: null,
  currentCoach: null,
  clientPayload: null,
  sections: null,
  destination: null,
  headCoach: null,
  activeGroupIsComplete: null,
  isMale: false,
  activeResponseFeedback: null,
  responseSaveError: false,
  notInterestedInLive: false,
  showDelaySurvey: false,
  openDelaySurvey: () => {},
  closeDelaySurvey: () => {},
  startShowDelaySurveyTimer: () => {},
  surveyViewedCount: 0,
  notInterestedInNutrition: false,
  isInsuranceClient: false,
  kickoffCallScheduledAt: null,
  setKickoffCallScheduledAt: date => {},
  setNeedMemberId: boolean => {},
  setCopay: copay => {},
  selectedPayer: null,
  setSelectedPayer: payer => {},
  setEligibilityStatus: status => {},
  setEligibilityData: data => {},
  policyMetadata: null,
  setPolicyMetadata: metadata => {},
  policyRetryCount: 0,
  setPolicyRetryCount: count => {},
  eligibilityStatus: null,
  eligibilityData: null,
  copay: null,
})
